// extracted by mini-css-extract-plugin
module.exports = {"container":"singleChart_container__sZlIP","title":"singleChart_title__3Luz6","chart":"singleChart_chart__29JQO"};